import UploadNewsForm from "../../UploadNewsForm";
import { createMiscellaneousNews } from "../../../api";
import { Container } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function CreateNewMiscellaneousNews() {
  const navigate = useNavigate();
  const customSubmitFunction = async (title, description, image) => {
    try {
      const result = await createMiscellaneousNews(title, description, image);
      if (result) {
        navigate("/miscellaneous-news/all");
      }
    } catch (error) {}
  };
  return (
    <>
      <Container>
        <UploadNewsForm
          customsubmit={customSubmitFunction}
          breadCrumbLink={"Miscellaneous News"}
          breadCrumbText={"Create New"}
          goBackLink={"/miscellaneous-news/all"}
        />
      </Container>
    </>
  );
}
